import { api } from "./api";
import { AuthResponse, User } from "../types";

export const authService = {
  // Google OAuth
  async loginWithGoogle(
    code: string,
    redirectUri: string,
  ): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>("/auth/google/code", {
      authorizationCode: code,
      redirectUri,
    });
    if (response.data.token) {
      localStorage.setItem("token", response.data.token);
    }
    return response.data;
  },

  async getCurrentUser(): Promise<User> {
    const response = await api.get<User>("/users/me");
    return response.data;
  },

  logout(): void {
    localStorage.removeItem("token");
    window.location.href = "/login";
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem("token");
  },

  getToken(): string | null {
    return localStorage.getItem("token");
  },

  async deleteAccount(userId: number): Promise<void> {
    await api.delete(`/users/${userId}`);
    localStorage.removeItem("token");
  },
};
